/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportHeaderType } from './reportHeaderType';
import { ReportType } from './reportType';


export interface EventReportType { 
    reportHeader: ReportHeaderType;
    report: ReportType;
}

